/* eslint-disable max-len */
import { MetadataContent } from '@jutro/legacy/uiconfig';
import React, { useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import metadata from './MLStickyContinueSectionComponent.metadata.json5';
import styles from './MLStickyContinueSectionComponent.module.scss';

const MLStickyContinueSectionComponent = (props) => {
    const { nextDescription, defaultContinueSectionId, onNext, disableNext, navButtonsContent_Ext, showReturnToQuote, canRequote, returnToQuoteFunction,isSticky=true } = props;

    const isScrolledIntoView = (elem) => {
        const docViewBottom = window.scrollY + window.innerHeight;
        const elemTop = elem.offsetTop;

        return (docViewBottom >= elemTop + 50);
    };

    const handleScrollEvent = () => {
        const stickyBar = document.getElementById('stickyContinueSection');
        const pageActionElem = document.getElementById(defaultContinueSectionId);

        if (_.isUndefined(_.get(stickyBar, 'classList', undefined))) {
            return;
        }

        if (defaultContinueSectionId) {
            if (pageActionElem && !isScrolledIntoView(pageActionElem)) {
                stickyBar.classList.add(styles.show);
            } else {
                stickyBar.classList.remove(styles.show);
            }
            return;
        }

        if (window.pageYOffset + window.innerHeight <= document.body.scrollHeight - 300) {
            stickyBar.classList.add(styles.show);
        } else {
            stickyBar.classList.remove(styles.show);
        }
    };

    useEffect(() => {
      if (isSticky) {
        handleScrollEvent();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
            if(isSticky){
        window.addEventListener('scroll', handleScrollEvent);
        return () => {
            window.removeEventListener('scroll', handleScrollEvent);
        };
    }
    });

    const generateContinueSectionOverrides_Ext = () => {
        if (navButtonsContent_Ext) {
            const overrides = [{
                'continueSection': {
                    content: navButtonsContent_Ext
                }
            }];
            return Object.assign({}, ...overrides);
        }
    };

    const overrides = {
        ...generateContinueSectionOverrides_Ext(),
        nextButton: {
            disabled: disableNext
        },
        nextDescription: {
            visible: !!nextDescription,
            content: nextDescription
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: !canRequote,
            onClick: returnToQuoteFunction
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLStickyContinueSectionComponent.propTypes = {
    disableNext: PropTypes.bool,
    nextDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    defaultContinueSectionId: PropTypes.string.isRequired,
    onNext: PropTypes.func.isRequired,
    showReturnToQuote: PropTypes.bool,
    canRequote: PropTypes.bool,
    returnToQuoteFunction: PropTypes.func
};

MLStickyContinueSectionComponent.defaultProps = {
    disableNext: false,
    nextDescription: undefined,
    showReturnToQuote: false,
    canRequote: false,
    returnToQuoteFunction: () => {}
}

export default MLStickyContinueSectionComponent;